var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 284,
    viewBox: "0 0 340 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1513_24865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7987 270.622C20.5148 279.374 30.5241 283.131 30.5241 283.131C30.5241 283.131 32.8871 272.698 28.171 263.947C23.4548 255.195 13.4455 251.438 13.4455 251.438C13.4455 251.438 11.0825 261.871 15.7987 270.622Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0402 267.743C27.5548 272.869 30.834 283.05 30.834 283.05C30.834 283.05 20.3084 284.92 11.7938 279.795C3.27923 274.669 0 264.488 0 264.488C0 264.488 10.5256 262.617 19.0402 267.743Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.938 13.634H156.813V14.3934H209.938V13.634Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.518 14.2036H194.759V21.2279H195.518V14.2036Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.371 14.2036H171.612V21.2279H172.371V14.2036Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.88 50.0845H183.755V50.8439H236.88V50.0845Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.934 43.25H198.175V50.2743H198.934V43.25Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.081 43.25H221.322V50.2743H222.081V43.25Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.46 67.1709H254.335V67.9303H307.46V67.1709Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.514 60.3364H268.755V67.3608H269.514V60.3364Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.661 60.3364H291.902V67.3608H292.661V60.3364Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.148 243.349H249.023V244.108H302.148V243.349Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.201 236.514H263.442V243.538H264.201V236.514Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.349 236.514H286.59V243.538H287.349V236.514Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.456 121.467H158.331V122.226H211.456V121.467Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.509 114.632H172.75V121.657H173.509V114.632Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.657 114.632H195.898V121.657H196.657V114.632Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.152 212.973H175.027V213.733H228.152V212.973Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.206 206.139H189.447V213.163H190.206V206.139Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.353 206.139H212.594V213.163H213.353V206.139Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.152 185.255H260.027V186.015H313.152V185.255Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.206 178.421H274.447V185.445H275.206V178.421Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.353 178.421H297.594V185.445H298.353V178.421Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.389 266.615H47.5371V265.968H136.742V234.598H55.0907L51.1242 226.329L51.707 226.049L55.4975 233.951H137.389V266.615Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4959 282.462C63.2444 282.462 66.2832 279.421 66.2832 275.67C66.2832 271.92 63.2444 268.879 59.4959 268.879C55.7473 268.879 52.7085 271.92 52.7085 275.67C52.7085 279.421 55.7473 282.462 59.4959 282.462Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.4 282.462C130.148 282.462 133.187 279.421 133.187 275.67C133.187 271.92 130.148 268.879 126.4 268.879C122.651 268.879 119.612 271.92 119.612 275.67C119.612 279.421 122.651 282.462 126.4 282.462Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.263 135.637C207.583 135.637 209.464 133.754 209.464 131.432C209.464 129.11 207.583 127.228 205.263 127.228C202.942 127.228 201.061 129.11 201.061 131.432C201.061 133.754 202.942 135.637 205.263 135.637Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.999 223.925H46.005L24.1523 152.453H169.504L169.372 152.874L146.999 223.925ZM46.4832 223.279H146.525L168.623 153.1H25.026L46.4832 223.279Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.116 220.207H50.4089L31.2148 156.819H158.882L158.766 157.193L139.116 220.207Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.315 146.068L170.69 145.902L174.955 129.815H199.768V130.462H175.453L171.315 146.068Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.241 174.122H31.2144V174.768H162.241V174.122Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.737 197.951H38.5V198.597H154.737V197.951Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6464 107H98V177.825H98.6464V107Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.09 152.756L121.45 223.58L122.095 223.622L126.736 152.799L126.09 152.756Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5753 152.756L66.9302 152.798L71.5435 223.623L72.1886 223.581L67.5753 152.756Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 282.872H0V283.631H340V282.872Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.937 23.494C225.937 23.494 231.484 39.2916 228.071 41.7221C224.657 44.1525 239.592 64.0008 239.592 64.0008L257.513 59.1399L247.699 42.5322C247.699 42.5322 246.419 25.9244 246.419 23.494C246.419 21.0636 225.937 23.494 225.937 23.494Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M225.937 23.494C225.937 23.494 231.484 39.2916 228.071 41.7221C224.657 44.1525 239.592 64.0008 239.592 64.0008L257.513 59.1399L247.699 42.5322C247.699 42.5322 246.419 25.9244 246.419 23.494C246.419 21.0636 225.937 23.494 225.937 23.494Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.626 136.103C216.626 136.103 215.007 156.356 216.626 166.888C218.245 177.42 220.674 206.584 220.674 206.584C220.674 206.584 220.674 261.674 229.58 262.484C238.486 263.294 244.964 264.104 245.773 260.864C246.583 257.623 241.725 256.003 244.154 254.382C246.583 252.762 247.392 247.091 244.154 240.61C240.915 234.129 244.154 168.508 244.154 168.508L259.537 209.825C259.537 209.825 261.156 243.851 262.776 248.711C264.395 253.572 261.156 262.484 266.824 263.294C272.492 264.104 278.969 259.243 282.207 257.623C285.446 256.003 277.349 256.003 278.969 255.193C280.588 254.382 285.446 251.952 283.827 251.142C282.207 250.332 280.588 211.445 280.588 211.445C280.588 211.445 276.135 128.406 270.467 125.166C264.8 121.925 261.156 127.507 261.156 127.507L216.626 136.103Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.2 259.243V265.724C231.2 265.724 223.913 283.342 231.2 283.342C238.487 283.342 244.154 285.167 244.154 282.737V260.863L231.2 259.243Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.969 259.232V265.713C278.969 265.713 286.256 283.331 278.969 283.331C271.682 283.331 266.015 285.156 266.015 282.726V260.852L278.969 259.232Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.272 35.2408C245.321 35.2408 251.846 28.712 251.846 20.6584C251.846 12.6047 245.321 6.07593 237.272 6.07593C229.224 6.07593 222.699 12.6047 222.699 20.6584C222.699 28.712 229.224 35.2408 237.272 35.2408Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.819 47.7979C232.819 47.7979 236.867 59.9499 243.344 57.5195L249.822 55.0891L261.157 132.862C261.157 132.862 252.25 145.824 239.296 137.723C226.342 129.622 232.819 47.7979 232.819 47.7979Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.154 45.3677L247.798 37.6714C247.798 37.6714 269.253 47.7981 272.492 51.0386C275.73 54.2792 275.73 59.14 275.73 59.14L270.063 79.3934C270.063 79.3934 271.682 123.951 271.682 125.571C271.682 127.191 277.35 136.103 273.302 132.862C269.253 129.622 268.444 126.381 265.205 131.242C261.967 136.103 254.68 141.774 254.68 141.774L244.154 45.3677Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.492 103.697L270.063 126.381C270.063 126.381 255.489 139.343 258.728 140.153C261.966 140.963 263.586 137.723 263.586 137.723C263.586 137.723 269.253 143.394 272.492 140.153C275.73 136.913 283.827 106.128 283.827 106.128L272.492 103.697Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.583 0.0493112C234.352 -0.0662561 230.894 -0.123423 228.17 1.61866C226.917 2.49294 225.818 3.5697 224.917 4.80488C222.264 8.16078 219.972 12.3833 220.958 16.547L222.102 16.1004C222.102 17.2118 221.855 18.3093 221.379 19.3136C221.54 18.8446 222.08 19.6027 221.936 20.0771L220.675 24.216C222.747 23.4557 225.326 24.9951 225.641 27.1813C225.785 22.3739 226.284 16.8613 230.181 14.0464C232.147 12.6269 234.634 12.1935 237.027 11.8087C239.235 11.4537 241.55 11.1152 243.664 11.8424C245.779 12.5697 247.58 14.7338 247.101 16.9193C248.076 16.5832 249.166 17.2632 249.648 18.1755C250.13 19.0879 250.155 20.1642 250.17 21.196C251.209 21.931 252.392 20.4715 252.816 19.2705C253.81 16.4516 254.694 13.4508 254.158 10.5099C253.623 7.56892 251.228 4.75838 248.24 4.74841C248.603 4.34985 248.796 3.82579 248.779 3.28706L246.317 3.07888C246.942 2.99031 247.517 2.68701 247.943 2.22094C246.955 3.3095 239.181 0.106497 237.583 0.0493112Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.867 42.9371C236.867 42.9371 230.276 36.4744 227.904 36.8703C225.532 37.2661 222.293 42.9371 222.293 42.9371C222.293 42.9371 202.862 49.4182 203.672 55.8993C204.481 62.3803 213.387 93.9756 213.387 93.9756C213.387 93.9756 220.674 132.052 214.197 136.103C207.72 140.153 244.964 150.685 245.773 145.824C246.583 140.963 248.202 92.3553 245.773 85.0641C243.344 77.7729 236.867 42.9371 236.867 42.9371Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.205 55.8994H275.216C275.216 55.8994 282.208 86.6846 283.017 89.9251C283.827 93.1656 285.446 108.558 284.637 108.558C283.827 108.558 267.634 105.318 267.634 107.748L265.205 55.8994Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.866 132.133H226.54C222.8 114.918 222.488 98.2851 226.54 82.3936H264.866C258.681 97.9992 258.295 114.518 264.866 132.133Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.958 110.989L222.294 115.849C222.294 115.849 244.154 119.09 244.154 110.178C244.154 101.267 222.294 106.128 222.294 106.128L215.006 103.796L210.958 110.989Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.387 51.0386L203.672 53.469L196.385 96.4061C196.385 96.4061 193.956 107.748 198.004 108.558C202.052 109.368 213.387 115.849 213.387 115.849C213.387 115.849 215.007 103.697 218.245 103.697L210.149 97.2163L215.007 68.8616L213.387 51.0386Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9873 133.997H22.8623V134.756H75.9873V133.997Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0407 127.163H37.2817V134.187H38.0407V127.163Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1881 127.163H60.4292V134.187H61.1881V127.163Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5811 21.6074H41.4561V22.3668H94.5811V21.6074Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1613 22.177H79.4023V29.2013H80.1613V22.177Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0138 22.177H56.2549V29.2013H57.0138V22.177Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.085 96.4072H94.9604V97.1666H148.085V96.4072Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.666 96.9766H132.907V104.001H133.666V96.9766Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.518 96.9766H109.759V104.001H110.518V96.9766Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7729 96.0273H4.64795V96.7867H57.7729V96.0273Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3532 96.5972H42.5942V103.621H43.3532V96.5972Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2057 96.5972H19.4468V103.621H20.2057V96.5972Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.523 58.0581H68.3979V58.8175H121.523V58.0581Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5763 51.2236H82.8174V58.248H83.5763V51.2236Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.724 51.2236H105.965V58.248H106.724V51.2236Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1513_24865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 284,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/Empty_Cart.cee2ffc8fe593650467c96930bf76470.svg";
export { ForwardRef as ReactComponent };